import type { Prototype } from "../prototype-types";

export const emilyChenPrototypes: Prototype[] = [
  {
    id: "insider-enrollment-benefits-modal",
    name: "Insider enrollment – Benefits modal",
    path: "/ec/insider-enrollment-benefits-modal",
    description:
      "Benefits modal for Insider enrollment: hero image, free shipping or savings-first variants, and primary CTA.",
    owner: "Emily",
    createdAt: "2026-03-12",
    lastUpdated: "2026-03-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "legacy",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/8cb7e077c485dfa5f30ea06f02707edd3e14269d35682e8935f10470eaf976a4.png",
    figmaLink:
      "https://www.figma.com/design/zQ9xpEHdCqpuNjs2RtomLv/Insider-Enrollment-Tests?node-id=316-29084",
    creationTool: "cursor",
  },
];
